import { render, staticRenderFns } from "./completedList.vue?vue&type=template&id=bcf49a64&scoped=true&"
import script from "./completedList.vue?vue&type=script&lang=js&"
export * from "./completedList.vue?vue&type=script&lang=js&"
import style0 from "./completedList.vue?vue&type=style&index=0&id=bcf49a64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf49a64",
  null
  
)

export default component.exports